import { SummaryMultipliers as Multipliers } from './SummaryMultipliers/SummaryMultipliers'
import { SummaryPerformance as Performance } from './SummaryPerformance/SummaryPerformance'
import { SummaryRuler as Ruler } from './SummaryRuler/SummaryRuler'

export default { Multipliers, Performance, Ruler }
